import { useEffect, useState } from "react";
import api from "../api/client";
import { Alert } from "../components/Ui";

export default function AdminOffers() {
  const [offers, setOffers] = useState([]);
  const [form, setForm] = useState({ title: "", discount: "", price: "", sold: "", rating: "5", link: "", order: "0" });
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const load = () => api.get("/admin/offers").then((r) => setOffers(r.data.offers || [])).catch(() => {});
  useEffect(() => { load(); }, []);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  function handleImage(e) {
    const file = e.target.files[0];
    if (!file) return;
    setImage(file);
    setPreview(URL.createObjectURL(file));
  }

  async function submit() {
    if (!form.title || !form.link || !image) return setError("Title, link and image are required.");
    setBusy(true); setError(null);
    try {
      const fd = new FormData();
      Object.entries(form).forEach(([k, v]) => fd.append(k, v));
      fd.append("image", image);
      await api.post("/admin/offers", fd, { headers: { "Content-Type": "multipart/form-data" } });
      setForm({ title: "", discount: "", price: "", sold: "", rating: "5", link: "", order: "0" });
      setImage(null); setPreview(null);
      load();
    } catch (e) { setError(e.message); }
    finally { setBusy(false); }
  }

  async function remove(id) {
    if (!window.confirm("Delete this offer?")) return;
    try { await api.delete(`/admin/offers/${id}`); load(); }
    catch (e) { setError(e.message); }
  }

  async function toggle(id) {
    try { await api.patch(`/admin/offers/${id}/toggle`); load(); }
    catch (e) { setError(e.message); }
  }

  return (
    <div>
      <h1>Flash Sale / Offers</h1>
      <p className="muted small" style={{ marginBottom: 20 }}>
        These appear as a horizontal sliding section on the home page.
      </p>

      <div className="card" style={{ padding: 20, marginBottom: 24 }}>
        <h3 style={{ fontSize: 14, margin: "0 0 12px" }}>Add new offer</h3>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
          <label><span className="muted small">Title *</span>
            <input className="input" value={form.title} onChange={(e) => set("title", e.target.value)} placeholder="Delta Force Coins" /></label>
          <label><span className="muted small">Link URL *</span>
            <input className="input" value={form.link} onChange={(e) => set("link", e.target.value)} placeholder="/game/68xxx or https://..." /></label>
          <label><span className="muted small">Discount badge</span>
            <input className="input" value={form.discount} onChange={(e) => set("discount", e.target.value)} placeholder="14% OFF" /></label>
          <label><span className="muted small">Price range</span>
            <input className="input" value={form.price} onChange={(e) => set("price", e.target.value)} placeholder="₹125 - ₹12,500" /></label>
          <label><span className="muted small">Sold count</span>
            <input className="input" value={form.sold} onChange={(e) => set("sold", e.target.value)} placeholder="116K+ Sold" /></label>
          <label><span className="muted small">Rating (0-5)</span>
            <input className="input" type="number" min="0" max="5" step="0.1" value={form.rating} onChange={(e) => set("rating", e.target.value)} /></label>
          <label><span className="muted small">Sort order</span>
            <input className="input" type="number" value={form.order} onChange={(e) => set("order", e.target.value)} /></label>
          <div>
            <span className="muted small" style={{ display: "block", marginBottom: 4 }}>Image *</span>
            <input type="file" accept="image/*" onChange={handleImage} />
          </div>
        </div>
        {preview && <img src={preview} alt="" style={{ width: 80, height: 80, borderRadius: 12, objectFit: "cover", marginBottom: 12 }} />}
        <Alert>{error}</Alert>
        <button className="btn primary" onClick={submit} disabled={busy}>{busy ? "Adding…" : "Add offer"}</button>
      </div>

      <div className="list">
        {offers.map((o) => (
          <div key={o._id} className="row" style={{ gap: 12 }}>
            <img src={`/${o.image}`} alt="" style={{ width: 56, height: 56, borderRadius: 10, objectFit: "cover" }}
              onError={(e) => { e.target.style.display = "none"; }} />
            <div className="grow">
              <div style={{ fontWeight: 700 }}>
                {o.title}
                {o.discount && <span style={{ marginLeft: 8, fontSize: 11, color: "#f43f5e", fontWeight: 800 }}>{o.discount}</span>}
              </div>
              <div className="muted small">{o.price} · {o.sold} · ⭐ {o.rating}</div>
            </div>
            <span className="muted small" style={{ minWidth: 50 }}>{o.active ? "Live" : "Hidden"}</span>
            <button className="btn ghost" style={{ padding: "6px 10px", fontSize: 11 }} onClick={() => toggle(o._id)}>
              {o.active ? "Hide" : "Show"}
            </button>
            <button className="btn ghost" style={{ padding: "6px 10px", fontSize: 11, color: "var(--bad)" }} onClick={() => remove(o._id)}>
              Delete
            </button>
          </div>
        ))}
        {offers.length === 0 && <p className="muted" style={{ padding: 24 }}>No offers yet.</p>}
      </div>
    </div>
  );
}